import { createFileRoute } from "@tanstack/react-router";
import AdminSetModuleDetailPage from "@/pages/admin/sets/detail/modules/detail";
import { useSetsPermissions } from "@/pages/admin/sets";

export const Route = createFileRoute("/app/admin/sets/$setId/modules/$moduleId")({
  component: RouteComponent,
});

function RouteComponent() {
  const { setId, moduleId } = Route.useParams();
  const { userCanEditAllSets, userCanViewAllSets, userCanViewAllPrograms } = useSetsPermissions();

  return (
    <AdminSetModuleDetailPage
      moduleId={Number(moduleId)}
      setId={Number(setId)}
      userCanEditAllSets={userCanEditAllSets}
      userCanViewAllSets={userCanViewAllSets}
      userCanViewAllPrograms={userCanViewAllPrograms}
    />
  );
}
